const STORAGE_KEY = 'fd_language';
const DEFAULT_LANGUAGE = 'fr';
const SUPPORTED_LANGUAGES = ['fr', 'en', 'es', 'pt'];

const DICTIONARY = {
  fr: {
    brandSubtitle: "Analyse tactique augmentée par l'IA",
    loginEyebrow: 'Portail Analyste',
    loginTitle: 'Décryptez<br>le jeu.',
    loginLead: 'Déposez une séquence de match, posez votre question tactique et obtenez un débrief complet — schéma de terrain animé, synthèse vocale, partage instantané.',
    continueGoogle: 'Continuer avec Google',
    continueMicrosoft: 'Continuer avec Microsoft',
    emailPlaceholder: 'adresse@email.com',
    receiveMagicLink: 'Recevoir le lien magique',
    supabaseMissing: 'Supabase non configuré — ajoutez VITE_SUPABASE_URL et VITE_SUPABASE_ANON_KEY dans .env',
    tacticalSimulation: 'Simulation Tactique',
    tacticalSimulationCopy: "Positions, trajectoires et zones d'influence calculées en temps réel par l'IA.",
    loginError: 'Erreur connexion : {message}',
    magicLinkSent: 'Lien de connexion envoyé. Vérifiez votre boîte mail.',
    emailError: 'Erreur email : {message}',
    navFeed: 'Feed',
    navAnalyze: 'Analyser',
    navCompetitions: 'Compét.',
    navTeams: 'Équipes',
    navQuiz: 'Quiz',
    navScores: 'Scores',
    navProfile: 'Profil',
    installApp: 'Installer fooview sur ton écran',
    install: 'Installer',
    newDebriefToast: 'Nouveau debrief dans ton feed.',
    configRequired: 'Configuration requise',
    addSupabaseEnv: 'Ajoute VITE_SUPABASE_URL et VITE_SUPABASE_ANON_KEY dans .env',
    userFallback: 'utilisateur',
    analysisCount: '{count} analyse{plural}',
    levelLine: 'Niveau {level} · {label}',
    tacticalPoints: '{points} points tactiques',
    analysesToday: "Analyses aujourd'hui: {count}/5",
    username: "Nom d'utilisateur",
    save: 'Enregistrer',
    pseudoHelp: '3 à 24 caractères : lettres, chiffres et underscore.',
    profilePhoto: 'Photo de profil',
    uploadPhoto: 'Importer une photo',
    remove: 'Supprimer',
    avatarPhotoHelp: "PNG, JPG, WebP ou GIF · 2 Mo max. La photo s'affiche en priorité sur l'emoji.",
    avatarEmoji: 'Avatar emoji',
    avatarEmojiPlaceholder: 'Ex: ⚽ 🦁 🔥',
    avatarEmojiHelp: "Repli si aucune photo. Laisse vide pour revenir à l'initiale de ton pseudo.",
    viewRankings: 'Voir mes classements',
    activeQuiz: 'Quiz actifs',
    personalGoals: 'Objectifs personnels',
    mvpPoints: 'MVP points',
    goalAnalysesWeek: '3 analyses cette semaine',
    goalCommentsWeek: '5 commentaires utiles',
    goalQuizDay: '1 quiz tactique par jour',
    levelRookie: 'Analyste en herbe',
    levelConfirmed: 'Analyste confirmé',
    levelElite: 'Analyste élite',
    noActiveGoal: 'Aucun objectif actif. Choisis un défi simple pour lancer ta série.',
    activate: 'Activer',
    pointsScale: 'Barème actuel : analyse +10, commentaire +3, réaction reçue +2, quiz +5.',
    searchFriend: 'Rechercher un ami',
    pseudoPlaceholder: 'Pseudo...',
    search: 'Chercher',
    pendingRequests: 'Demandes en attente ({count})',
    accept: 'Accepter',
    reject: 'Refuser',
    friends: 'Amis ({count})',
    noFriends: "Aucun ami pour l'instant",
    appGuide: "Guide de l'app",
    appGuideCopy: 'Résumé rapide des sections et des fonctions disponibles.',
    openGuide: 'Ouvrir le guide',
    preferences: 'Préférences',
    language: 'Langue',
    french: 'Français',
    english: 'Anglais',
    spanish: 'Espagnol',
    portuguese: 'Portugais',
    appearance: 'Apparence',
    light: 'Clair',
    dark: 'Sombre',
    logout: 'Se déconnecter',
    pseudoUpToDate: 'Pseudo déjà à jour.',
    pseudoTaken: 'Ce pseudo est déjà pris.',
    pseudoNotUpdated: 'Pseudo non mis à jour: {message}',
    pseudoLocked: 'Pseudo non mis à jour: session expirée ou profil verrouillé.',
    pseudoUpdated: 'Pseudo mis à jour.',
    noResults: 'Aucun résultat',
    add: 'Ajouter',
    goalsUnavailable: 'Objectifs indisponibles: applique la migration Supabase.',
    goalActivated: 'Objectif activé.',
    avatarUnavailable: 'Avatar indisponible: applique la migration Supabase.',
    emojiUpdated: 'Emoji mis à jour.',
    emojiReset: 'Emoji réinitialisé.',
    unsupportedFormat: 'Format non supporté (PNG, JPG, WebP ou GIF).',
    imageTooHeavy: 'Image trop lourde (2 Mo max).',
    uploading: 'Envoi…',
    uploadUnavailable: 'Upload impossible: applique la migration Storage.',
    profileNotUpdated: 'Profil non mis à jour: {message}',
    photoUpdated: 'Photo mise à jour.',
    deleteFailed: 'Suppression impossible: {message}',
    photoDeleted: 'Photo supprimée.',
    genericError: 'Erreur: {message}',
    sent: 'Envoyé',
    homeEmptyTitle: 'Aucune analyse disponible'
  },
  en: {
    brandSubtitle: 'AI-powered tactical analysis',
    loginEyebrow: 'Analyst Portal',
    loginTitle: 'Read<br>the game.',
    loginLead: 'Upload a match sequence, ask your tactical question, and get a complete debrief with an animated pitch, voice summary, and instant sharing.',
    continueGoogle: 'Continue with Google',
    continueMicrosoft: 'Continue with Microsoft',
    emailPlaceholder: 'name@email.com',
    receiveMagicLink: 'Get magic link',
    supabaseMissing: 'Supabase is not configured — add VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY to .env',
    tacticalSimulation: 'Tactical Simulation',
    tacticalSimulationCopy: 'Positions, runs, and influence zones calculated in real time by AI.',
    loginError: 'Login error: {message}',
    magicLinkSent: 'Login link sent. Check your inbox.',
    emailError: 'Email error: {message}',
    navFeed: 'Feed',
    navAnalyze: 'Analyze',
    navCompetitions: 'Comps',
    navTeams: 'Teams',
    navQuiz: 'Quiz',
    navScores: 'Scores',
    navProfile: 'Profile',
    installApp: 'Install fooview on your home screen',
    install: 'Install',
    newDebriefToast: 'New debrief in your feed.',
    configRequired: 'Configuration required',
    addSupabaseEnv: 'Add VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY to .env',
    userFallback: 'user',
    analysisCount: '{count} analysis{plural}',
    levelLine: 'Level {level} · {label}',
    tacticalPoints: '{points} tactical points',
    analysesToday: 'Analyses today: {count}/5',
    username: 'Username',
    save: 'Save',
    pseudoHelp: '3 to 24 characters: letters, numbers, and underscores.',
    profilePhoto: 'Profile photo',
    uploadPhoto: 'Upload photo',
    remove: 'Remove',
    avatarPhotoHelp: 'PNG, JPG, WebP, or GIF · 2 MB max. The photo is shown before the emoji.',
    avatarEmoji: 'Emoji avatar',
    avatarEmojiPlaceholder: 'Ex: ⚽ 🦁 🔥',
    avatarEmojiHelp: 'Fallback when there is no photo. Leave empty to use your username initial.',
    viewRankings: 'View my rankings',
    activeQuiz: 'Active quizzes',
    personalGoals: 'Personal goals',
    mvpPoints: 'MVP points',
    goalAnalysesWeek: '3 analyses this week',
    goalCommentsWeek: '5 useful comments',
    goalQuizDay: '1 tactical quiz per day',
    levelRookie: 'Rising analyst',
    levelConfirmed: 'Confirmed analyst',
    levelElite: 'Elite analyst',
    noActiveGoal: 'No active goal. Pick a simple challenge to start your streak.',
    activate: 'Activate',
    pointsScale: 'Current scale: analysis +10, comment +3, reaction received +2, quiz +5.',
    searchFriend: 'Find a friend',
    pseudoPlaceholder: 'Username...',
    search: 'Search',
    pendingRequests: 'Pending requests ({count})',
    accept: 'Accept',
    reject: 'Reject',
    friends: 'Friends ({count})',
    noFriends: 'No friends yet',
    appGuide: 'App guide',
    appGuideCopy: 'Quick summary of the available sections and features.',
    openGuide: 'Open guide',
    preferences: 'Preferences',
    language: 'Language',
    french: 'French',
    english: 'English',
    spanish: 'Spanish',
    portuguese: 'Portuguese',
    appearance: 'Appearance',
    light: 'Light',
    dark: 'Dark',
    logout: 'Sign out',
    pseudoUpToDate: 'Username is already up to date.',
    pseudoTaken: 'This username is already taken.',
    pseudoNotUpdated: 'Username not updated: {message}',
    pseudoLocked: 'Username not updated: session expired or profile locked.',
    pseudoUpdated: 'Username updated.',
    noResults: 'No results',
    add: 'Add',
    goalsUnavailable: 'Goals unavailable: apply the Supabase migration.',
    goalActivated: 'Goal activated.',
    avatarUnavailable: 'Avatar unavailable: apply the Supabase migration.',
    emojiUpdated: 'Emoji updated.',
    emojiReset: 'Emoji reset.',
    unsupportedFormat: 'Unsupported format (PNG, JPG, WebP, or GIF).',
    imageTooHeavy: 'Image too large (2 MB max).',
    uploading: 'Uploading…',
    uploadUnavailable: 'Upload unavailable: apply the Storage migration.',
    profileNotUpdated: 'Profile not updated: {message}',
    photoUpdated: 'Photo updated.',
    deleteFailed: 'Delete failed: {message}',
    photoDeleted: 'Photo removed.',
    genericError: 'Error: {message}',
    sent: 'Sent',
    homeEmptyTitle: 'No analysis available'
  },
  es: {
    brandSubtitle: 'Análisis táctico impulsado por IA',
    loginEyebrow: 'Portal del analista',
    loginTitle: 'Lee<br>el juego.',
    loginLead: 'Sube una secuencia de partido, plantea tu pregunta táctica y recibe un informe completo con pizarra animada, resumen de voz y uso compartido instantáneo.',
    continueGoogle: 'Continuar con Google',
    continueMicrosoft: 'Continuar con Microsoft',
    emailPlaceholder: 'nombre@email.com',
    receiveMagicLink: 'Recibir enlace mágico',
    supabaseMissing: 'Supabase no está configurado — añade VITE_SUPABASE_URL y VITE_SUPABASE_ANON_KEY en .env',
    tacticalSimulation: 'Simulación táctica',
    tacticalSimulationCopy: 'Posiciones, desmarques y zonas de influencia calculadas en tiempo real por la IA.',
    loginError: 'Error de conexión: {message}',
    magicLinkSent: 'Enlace de acceso enviado. Revisa tu bandeja de entrada.',
    emailError: 'Error de email: {message}',
    navFeed: 'Feed',
    navAnalyze: 'Analizar',
    navCompetitions: 'Comp.',
    navTeams: 'Equipos',
    navQuiz: 'Quiz',
    navScores: 'Puntos',
    navProfile: 'Perfil',
    installApp: 'Instalar fooview en tu pantalla de inicio',
    install: 'Instalar',
    newDebriefToast: 'Nuevo informe en tu feed.',
    configRequired: 'Configuración requerida',
    addSupabaseEnv: 'Añade VITE_SUPABASE_URL y VITE_SUPABASE_ANON_KEY en .env',
    userFallback: 'usuario',
    analysisCount: '{count} análisis',
    levelLine: 'Nivel {level} · {label}',
    tacticalPoints: '{points} puntos tácticos',
    analysesToday: 'Análisis hoy: {count}/5',
    username: 'Nombre de usuario',
    save: 'Guardar',
    pseudoHelp: 'De 3 a 24 caracteres: letras, números y guion bajo.',
    profilePhoto: 'Foto de perfil',
    uploadPhoto: 'Subir foto',
    remove: 'Eliminar',
    avatarPhotoHelp: 'PNG, JPG, WebP o GIF · 2 MB máx. La foto se muestra antes que el emoji.',
    avatarEmoji: 'Avatar emoji',
    avatarEmojiPlaceholder: 'Ej.: ⚽ 🦁 🔥',
    avatarEmojiHelp: 'Alternativa si no hay foto. Déjalo vacío para usar la inicial de tu nombre.',
    viewRankings: 'Ver mis clasificaciones',
    activeQuiz: 'Quizzes activos',
    personalGoals: 'Objetivos personales',
    mvpPoints: 'Puntos MVP',
    goalAnalysesWeek: '3 análisis esta semana',
    goalCommentsWeek: '5 comentarios útiles',
    goalQuizDay: '1 quiz táctico al día',
    levelRookie: 'Analista emergente',
    levelConfirmed: 'Analista confirmado',
    levelElite: 'Analista élite',
    noActiveGoal: 'No hay objetivos activos. Elige un reto sencillo para empezar tu racha.',
    activate: 'Activar',
    pointsScale: 'Escala actual: análisis +10, comentario +3, reacción recibida +2, quiz +5.',
    searchFriend: 'Buscar un amigo',
    pseudoPlaceholder: 'Usuario...',
    search: 'Buscar',
    pendingRequests: 'Solicitudes pendientes ({count})',
    accept: 'Aceptar',
    reject: 'Rechazar',
    friends: 'Amigos ({count})',
    noFriends: 'Aún no tienes amigos',
    appGuide: 'Guía de la app',
    appGuideCopy: 'Resumen rápido de las secciones y funciones disponibles.',
    openGuide: 'Abrir guía',
    preferences: 'Preferencias',
    language: 'Idioma',
    french: 'Francés',
    english: 'Inglés',
    spanish: 'Español',
    portuguese: 'Portugués',
    appearance: 'Apariencia',
    light: 'Claro',
    dark: 'Oscuro',
    logout: 'Cerrar sesión',
    pseudoUpToDate: 'El nombre de usuario ya está actualizado.',
    pseudoTaken: 'Este nombre de usuario ya está en uso.',
    pseudoNotUpdated: 'Nombre de usuario no actualizado: {message}',
    pseudoLocked: 'Nombre de usuario no actualizado: sesión expirada o perfil bloqueado.',
    pseudoUpdated: 'Nombre de usuario actualizado.',
    noResults: 'Sin resultados',
    add: 'Añadir',
    goalsUnavailable: 'Objetivos no disponibles: aplica la migración Supabase.',
    goalActivated: 'Objetivo activado.',
    avatarUnavailable: 'Avatar no disponible: aplica la migración Supabase.',
    emojiUpdated: 'Emoji actualizado.',
    emojiReset: 'Emoji restablecido.',
    unsupportedFormat: 'Formato no compatible (PNG, JPG, WebP o GIF).',
    imageTooHeavy: 'Imagen demasiado pesada (2 MB máx.).',
    uploading: 'Subiendo…',
    uploadUnavailable: 'Subida no disponible: aplica la migración Storage.',
    profileNotUpdated: 'Perfil no actualizado: {message}',
    photoUpdated: 'Foto actualizada.',
    deleteFailed: 'No se pudo eliminar: {message}',
    photoDeleted: 'Foto eliminada.',
    genericError: 'Error: {message}',
    sent: 'Enviado',
    homeEmptyTitle: 'No hay análisis disponibles'
  },
  pt: {
    brandSubtitle: 'Análise tática com IA',
    loginEyebrow: 'Portal do analista',
    loginTitle: 'Leia<br>o jogo.',
    loginLead: 'Carrega uma sequência do jogo, faz a tua pergunta tática e recebe um debrief completo com quadro animado, resumo por voz e partilha instantânea.',
    continueGoogle: 'Continuar com Google',
    continueMicrosoft: 'Continuar com Microsoft',
    emailPlaceholder: 'nome@email.com',
    receiveMagicLink: 'Receber link mágico',
    supabaseMissing: 'Supabase não configurado — adiciona VITE_SUPABASE_URL e VITE_SUPABASE_ANON_KEY em .env',
    tacticalSimulation: 'Simulação tática',
    tacticalSimulationCopy: 'Posições, movimentos e zonas de influência calculados em tempo real pela IA.',
    loginError: 'Erro de login: {message}',
    magicLinkSent: 'Link de acesso enviado. Verifica a tua caixa de entrada.',
    emailError: 'Erro de email: {message}',
    navFeed: 'Feed',
    navAnalyze: 'Analisar',
    navCompetitions: 'Comp.',
    navTeams: 'Equipas',
    navQuiz: 'Quiz',
    navScores: 'Pontos',
    navProfile: 'Perfil',
    installApp: 'Instalar fooview no ecrã inicial',
    install: 'Instalar',
    newDebriefToast: 'Novo debrief no teu feed.',
    configRequired: 'Configuração necessária',
    addSupabaseEnv: 'Adiciona VITE_SUPABASE_URL e VITE_SUPABASE_ANON_KEY em .env',
    userFallback: 'utilizador',
    analysisCount: '{count} análise(s)',
    levelLine: 'Nível {level} · {label}',
    tacticalPoints: '{points} pontos táticos',
    analysesToday: 'Análises hoje: {count}/5',
    username: 'Nome de utilizador',
    save: 'Guardar',
    pseudoHelp: '3 a 24 caracteres: letras, números e underscore.',
    profilePhoto: 'Foto de perfil',
    uploadPhoto: 'Carregar foto',
    remove: 'Remover',
    avatarPhotoHelp: 'PNG, JPG, WebP ou GIF · 2 MB máx. A foto aparece antes do emoji.',
    avatarEmoji: 'Avatar emoji',
    avatarEmojiPlaceholder: 'Ex.: ⚽ 🦁 🔥',
    avatarEmojiHelp: 'Alternativa se não houver foto. Deixa vazio para usar a inicial do teu nome.',
    viewRankings: 'Ver os meus rankings',
    activeQuiz: 'Quizzes ativos',
    personalGoals: 'Objetivos pessoais',
    mvpPoints: 'Pontos MVP',
    goalAnalysesWeek: '3 análises esta semana',
    goalCommentsWeek: '5 comentários úteis',
    goalQuizDay: '1 quiz tático por dia',
    levelRookie: 'Analista em evolução',
    levelConfirmed: 'Analista confirmado',
    levelElite: 'Analista de elite',
    noActiveGoal: 'Nenhum objetivo ativo. Escolhe um desafio simples para começar a sequência.',
    activate: 'Ativar',
    pointsScale: 'Escala atual: análise +10, comentário +3, reação recebida +2, quiz +5.',
    searchFriend: 'Procurar um amigo',
    pseudoPlaceholder: 'Utilizador...',
    search: 'Procurar',
    pendingRequests: 'Pedidos pendentes ({count})',
    accept: 'Aceitar',
    reject: 'Recusar',
    friends: 'Amigos ({count})',
    noFriends: 'Ainda não tens amigos',
    appGuide: 'Guia da app',
    appGuideCopy: 'Resumo rápido das secções e funcionalidades disponíveis.',
    openGuide: 'Abrir guia',
    preferences: 'Preferências',
    language: 'Idioma',
    french: 'Francês',
    english: 'Inglês',
    spanish: 'Espanhol',
    portuguese: 'Português',
    appearance: 'Aparência',
    light: 'Claro',
    dark: 'Escuro',
    logout: 'Terminar sessão',
    pseudoUpToDate: 'O nome de utilizador já está atualizado.',
    pseudoTaken: 'Este nome de utilizador já existe.',
    pseudoNotUpdated: 'Nome de utilizador não atualizado: {message}',
    pseudoLocked: 'Nome de utilizador não atualizado: sessão expirada ou perfil bloqueado.',
    pseudoUpdated: 'Nome de utilizador atualizado.',
    noResults: 'Sem resultados',
    add: 'Adicionar',
    goalsUnavailable: 'Objetivos indisponíveis: aplica a migração Supabase.',
    goalActivated: 'Objetivo ativado.',
    avatarUnavailable: 'Avatar indisponível: aplica a migração Supabase.',
    emojiUpdated: 'Emoji atualizado.',
    emojiReset: 'Emoji reposto.',
    unsupportedFormat: 'Formato não suportado (PNG, JPG, WebP ou GIF).',
    imageTooHeavy: 'Imagem demasiado pesada (2 MB máx.).',
    uploading: 'A carregar…',
    uploadUnavailable: 'Upload indisponível: aplica a migração Storage.',
    profileNotUpdated: 'Perfil não atualizado: {message}',
    photoUpdated: 'Foto atualizada.',
    deleteFailed: 'Não foi possível eliminar: {message}',
    photoDeleted: 'Foto removida.',
    genericError: 'Erro: {message}',
    sent: 'Enviado',
    homeEmptyTitle: 'Nenhuma análise disponível'
  }
};

export function getLanguage() {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (SUPPORTED_LANGUAGES.includes(saved)) return saved;
  } catch {}
  return DEFAULT_LANGUAGE;
}

export function setLanguage(language) {
  const next = SUPPORTED_LANGUAGES.includes(language) ? language : DEFAULT_LANGUAGE;
  try { localStorage.setItem(STORAGE_KEY, next); } catch {}
  document.documentElement.lang = next;
  window.dispatchEvent(new CustomEvent('fd:languagechange', { detail: { language: next } }));
  return next;
}

export function initLanguage() {
  document.documentElement.lang = getLanguage();
}

export function t(key, params = {}) {
  const language = getLanguage();
  const template = DICTIONARY[language]?.[key] || DICTIONARY[DEFAULT_LANGUAGE]?.[key] || key;
  return template.replace(/\{(\w+)\}/g, (_, name) => String(params[name] ?? ''));
}

export function isEnglish() {
  return getLanguage() === 'en';
}

export function usesEnglishContentFallback() {
  return getLanguage() !== DEFAULT_LANGUAGE;
}

export function tr(fr, en, es = en, pt = en) {
  const language = getLanguage();
  if (language === 'en') return en ?? fr;
  if (language === 'es') return es ?? en ?? fr;
  if (language === 'pt') return pt ?? en ?? fr;
  return fr;
}

export function currentLocale() {
  const language = getLanguage();
  if (language === 'en') return 'en-US';
  if (language === 'es') return 'es-ES';
  if (language === 'pt') return 'pt-PT';
  return 'fr-FR';
}

export function formatNumber(value, options = {}) {
  const number = Number(value);
  const safeNumber = Number.isFinite(number) ? number : 0;
  return new Intl.NumberFormat(currentLocale(), options).format(safeNumber);
}

export function formatFileSize(bytes, { fractionDigits = 2 } = {}) {
  const number = Number(bytes);
  const megabytes = Number.isFinite(number) && number > 0 ? number / 1024 / 1024 : 0;
  const unit = getLanguage() === DEFAULT_LANGUAGE ? 'Mo' : 'MB';
  return `${formatNumber(megabytes, {
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits
  })} ${unit}`;
}

export function formatDurationSeconds(seconds, { fractionDigits = 1 } = {}) {
  return `${formatNumber(seconds, {
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits
  })} s`;
}

export function formatLocalizedDateTime(value, options = {}) {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  return new Intl.DateTimeFormat(currentLocale(), options).format(date);
}

export function supportedLanguages() {
  return [...SUPPORTED_LANGUAGES];
}
